import { render, staticRenderFns } from "./customer_detail.vue?vue&type=template&id=3377986a&scoped=true"
import script from "./customer_detail.vue?vue&type=script&lang=js"
export * from "./customer_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3377986a",
  null
  
)

export default component.exports